var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-outline/funnel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M16.0002 3.99988C19.6731 3.99988 23.2738 4.30928 26.7775 4.90343C27.488 5.02391 28.0001 5.64461 28.0001 6.36524V7.75724C28.0001 8.55289 27.6841 9.31595 27.1214 9.87856L19.8788 17.1212C19.3162 17.6838 19.0001 18.4469 19.0001 19.2425V23.1458C19.0001 24.2821 18.3581 25.3209 17.3418 25.8291L13.0001 27.9999V19.2425C13.0001 18.4469 12.6841 17.6838 12.1214 17.1212L4.8788 9.87856C4.31619 9.31595 4.00012 8.55289 4.00012 7.75724V6.36527C4.00012 5.64464 4.51223 5.02395 5.22271 4.90346C8.72651 4.30929 12.3272 3.99988 16.0002 3.99988Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.b0be453324d44b9970589e83a9155423.svg";
export { ForwardRef as ReactComponent };